import React from "react";
import {
  ContactColumn1,
  ContactColumn2,
  ContactContainer,
  ContactHeading,
  ContactImg,
  ContactImgWrap,
  ContactRow,
  ContactSubtitle,
  ContactTextWrapper,
  ContactTopLine,
  ContactWrapper,
  SocialMediaIconLink,
  SocialMediaIcons,
  SocialMediaWrapper,
} from "./ContactStyle";

import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaPhone,
} from "react-icons/fa";

import svg6 from "../../images/svg_9.svg";

const Contact = () => {
  return (
    <ContactContainer id="contact">
      <ContactWrapper imageStart={true}>
        <ContactRow>
          <ContactColumn1>
            <ContactTextWrapper>
              <ContactTopLine>Contact</ContactTopLine>
              <ContactHeading lightText={true}>Kartik Jha</ContactHeading>
              <ContactSubtitle>Lets get in touch!</ContactSubtitle>
              <SocialMediaWrapper>
                <SocialMediaIcons>
                  <SocialMediaIconLink
                    href=""
                    target="_blank"
                    aria-label="Linkedin"
                  >
                    <FaLinkedin />
                  </SocialMediaIconLink>
                  <SocialMediaIconLink
                    href="https://www.facebook.com/kartik.jha.1217/"
                    target="_blank"
                    aria-label="Facebook"
                  >
                    <FaFacebook />
                  </SocialMediaIconLink>
                  <SocialMediaIconLink
                    href="tel:+91 860-564-0371"
                    target="_blank"
                    aria-label="Phone"
                  >
                    <FaPhone />
                  </SocialMediaIconLink>

                  <SocialMediaIconLink
                    href="https://www.instagram.com/lazy_illiterate_bernard/"
                    target="_blank"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </SocialMediaIconLink>
                  <SocialMediaIconLink
                    href="https://github.com/AlistairHeus/"
                    target="_blank"
                    aria-label="Github"
                  >
                    <FaGithub />
                  </SocialMediaIconLink>
                </SocialMediaIcons>
              </SocialMediaWrapper>
            </ContactTextWrapper>
          </ContactColumn1>
          <ContactColumn2>
            <ContactImgWrap>
              <ContactImg src={svg6} alt="" />
            </ContactImgWrap>
          </ContactColumn2>
        </ContactRow>
      </ContactWrapper>
    </ContactContainer>
  );
};

export default Contact;
